module.exports = __webpack_public_path__ + "img/graduation.36169460.svg";